export default __webpack_public_path__ + "static/media/cloud-2.1e1ae208.webp";